// extracted by mini-css-extract-plugin
export default {"section_select":"PatientsSectionDropdown_section_select__yejcU","select_menu_root":"PatientsSectionDropdown_select_menu_root__5E2le"};